import { ColumnDefinition, ChartDefinition } from '@/features/report-snapshots/api/schema';
import { useFormatters } from '@/features/report-snapshots/formatters/use-formatters';

export function getTargetStatus(
  rawValue: unknown,
  target: ChartDefinition['visualizationOptions']['target'],
  columnDefinition: ColumnDefinition,
  formatters: ReturnType<typeof useFormatters>,
) {
  const { unit, fractionUnit, improvementDirection } = columnDefinition;

  if (!target || !improvementDirection) {
    return '';
  }

  let cellValue = rawValue as number | null;

  if (unit === 'percent' || unit === 'ratio') {
    const value = rawValue as { numerator: number; denominator: number };
    const fraction = {
      numerator: { value: value.numerator, unit: fractionUnit?.numerator ?? 'value' },
      denominator: { value: value.denominator, unit: fractionUnit?.denominator ?? 'value' },
    };
    const formattedValue = formatters.valueFormatters(fraction, unit);

    cellValue = parseFloat(formattedValue);
  }

  if (cellValue === null || isNaN(cellValue)) {
    return '';
  }

  if (improvementDirection === 'increasing') {
    return cellValue >= target.value ? 'bg-success-container' : 'bg-error-container';
  } else {
    return cellValue <= target.value ? 'bg-success-container' : 'bg-error-container';
  }
}
